import { useEffect } from "react";
import queryString from "query-string";
import { createCookie, getCookie } from "util/cookie";
import validQueryParams from "util/valid-query-params";
import {
  BrandMarquee,
  CtaBanner,
  Features,
  FeatureShowcase,
  Hero,
  HomeV2Footer,
  Stats,
  StickyHeader,
  Testimonial,
  ViralSocialActions,
} from "./sections";

/**
 * Public homepage served at /home.
 *
 * Composes all marketing sections on a single responsive page and preserves the
 * referral-cookie lookup side-effect from the legacy Home component.
 *
 * Title/meta/OG tags live in `server/home-v2.ejs`, not here: this page skips SSR,
 * so anything rendered by react-helmet is invisible to crawlers and scrapers.
 *
 * @param {Object} props
 * @param {{ search: string }} props.location - react-router location
 * @returns {import("react").ReactElement}
 */
export function HomeV2(props) {
  const { location } = props;

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.scrollTo(0, 0);

    const parsed = queryString.parse(location?.search ?? "");
    validQueryParams.forEach((param) => {
      if (parsed[param] && !getCookie(param)) {
        createCookie(param, parsed[param], 7);
      }
    });
  }, [location?.search]);

  return (
    <div className="font-display text-ink bg-[#FBFCFD] antialiased **:font-features-['ss01','cv11']">
      <StickyHeader />
      <Hero />
      <BrandMarquee />
      <Features />
      <FeatureShowcase />
      <ViralSocialActions />
      <Stats />
      <Testimonial />
      <CtaBanner />
      <HomeV2Footer />
    </div>
  );
}
